export const APP_NAME = 'Firebase Quickstart';
export const APP_NAME_SHORT = 'FQS';
export const COMPANY_NAME = 'Firebase Quickstart, LLC';
